"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileRestaurantsMap = void 0;
const React = require("react");
const react_1 = require("react");
const SelectRestaurantMap_1 = require("../../../atoms/SelectRestaurantMap");
const RetailLocationCard_1 = require("../../../atoms/RetailLocationCard");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const restaurantCard_1 = require("../../../helpers/restaurantCard");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "MobileRestaurantsMap");
const mapId = "mobileMap";
const MobileRestaurantsMap = ({ restaurants, viewOption, setViewOption, selectRestaurant, currentOrderType }) => {
    const { retailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const [mapHeight, setMapHeight] = (0, react_1.useState)(0);
    const [selectedRestaurant, setSelectedRestaurant] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!retailLocation) {
            return;
        }
        setSelectedRestaurant(retailLocation);
    }, [retailLocation]);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            const element = document.getElementById(mapId);
            if (!element) {
                return;
            }
            const height = element.parentElement.offsetHeight;
            if (!height) {
                setViewOption(0);
            }
            if (selectedRestaurant) {
                const restaurantCard = (0, restaurantCard_1.getRestaurantCard)(selectedRestaurant);
                const image = restaurantCard.firstElementChild;
                const setHeight = height * 0.225;
                if (setHeight >= 50) {
                    image.style.setProperty("max-height", `${height * 0.225}px`);
                }
            }
            setMapHeight(height);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, [viewOption, selectedRestaurant]);
    return (React.createElement("div", { id: css(mapId), className: css("") },
        React.createElement(SelectRestaurantMap_1.SelectRestaurantMap, { restaurants: restaurants, mapId: mapId, mapHeight: mapHeight, onRestaurantMarkerClick: restaurant => {
                setSelectedRestaurant(restaurant);
            } }),
        selectedRestaurant && (React.createElement("div", { className: css("selectedRestaurant") },
            React.createElement("div", { className: css("selectedRestaurant_inner") },
                React.createElement(RetailLocationCard_1.RetailLocationCard, { retailLocation: selectedRestaurant, onClick: async () => {
                        await selectRestaurant(selectedRestaurant);
                    }, orderType: currentOrderType }))))));
};
exports.MobileRestaurantsMap = MobileRestaurantsMap;
//# sourceMappingURL=index.js.map